export enum ADMIN_PERMISSION_RESOURCE_TYPE {
  APP_SETUP = 'app_setup',
  PARISH_INFO = 'parish_info',
  MEMBERS = 'members',
  TEXT_CREDIT = 'text_credit',
}

export enum ADMIN_PERMISSION_ACCESS_LEVEL {
  EDIT = 'edit',
  VIEW_ONLY = 'view_only',
  DENY = 'deny',
}

export type AdminPermission = {
  resourceType: ADMIN_PERMISSION_RESOURCE_TYPE;
  accessLevel: ADMIN_PERMISSION_ACCESS_LEVEL;
};

export type AdminMembersAccessItem = {
  id: string;
  accessLevel: ADMIN_PERMISSION_ACCESS_LEVEL.EDIT | ADMIN_PERMISSION_ACCESS_LEVEL.VIEW_ONLY;
};

export type AdminMembersAccessPermission = {
  resourceType?: ADMIN_PERMISSION_RESOURCE_TYPE | string;
  accessLevel?: ADMIN_PERMISSION_ACCESS_LEVEL | string;
};

export type AdminMembersAccessApiItem = {
  id?: string;
  userId?: string;
  accessLevel?: ADMIN_PERMISSION_ACCESS_LEVEL | string;
  permissions?: AdminMembersAccessPermission[];
};
